/*
 * Regarding Google Sheets API Usage Limits:
 * This version of the Google Sheets API has a limit of 500 requests per 100 seconds per project, and 100 requests per 100 seconds per user. Limits for reads and writes are tracked separately. There is no daily usage limit.
 *
 *
 * PORTED TO OFFLINE -- SAVED AS STRING CONSTANTS AND JSON PARSED.
 */

import { ConnectorType, CourseData } from "../datastructures/coursedata";
import { EdgeMode, IConnector, ICourseNode } from "../datastructures/dataviz";
// import {CourseMapJSON} from '../database/coursemapjson'
import data from "./data.json";
export const InitializeCoursemapDatabase = async () => {
  /*
  let CourseDatabase: CourseData[] = []

  const doc = new GoogleSpreadsheet('1A4PmA1vvH18qIZBPB-gn-ggouTom6zaFCcaX9eP5ps0');
  doc.useApiKey('AIzaSyC_WM4rwzPvsqpdyuF-K_gg9bFhZswbGi8'); //privatize later
  // Check the link! https://docs.google.com/spreadsheets/d/1A4PmA1vvH18qIZBPB-gn-ggouTom6zaFCcaX9eP5ps0/edit

  await doc.loadInfo(); // loads document properties and worksheets

  const sheet = doc.sheetsByTitle['Course Data']; // or use doc.sheetsById[id] or doc.sheetsByTitle[title]
  await sheet.loadCells(`A1:K${1 + numCourses}`) //num cells for AX:IY = (y-x)+1

  //parsing raw data into CourseData objects and pushing into array
  for (var courseIdx = 0; courseIdx < numCourses; courseIdx++) {
    let course: CourseData = {
      courseCode: sheet.getCell((courseIdx + 1), 0).value.toString(),
      courseName: sheet.getCell((courseIdx + 1), 1).value.toString(),
      courseDescr: sheet.getCell((courseIdx + 1), 2).value != null ? sheet.getCell((courseIdx + 1), 2).value.toString() : 'No description available.',
      coursePrereqs: sheet.getCell((courseIdx + 1), 3).value != null ? sheet.getCell((courseIdx + 1), 3).value.toString().split(' ') : ['none'],
      courseCoreqs: sheet.getCell((courseIdx + 1), 4).value != null ? sheet.getCell((courseIdx + 1), 4).value.toString().split(' ') : ['none'],
      courseOptPrereqs: sheet.getCell((courseIdx + 1), 5).value != null ? sheet.getCell((courseIdx + 1), 5).value.toString().split(' ') : ['none'],
      courseRelated: sheet.getCell((courseIdx + 1), 9).value != null ? sheet.getCell((courseIdx + 1), 9).value.toString().split(' ') : ['none'],
      courseIsKernel: sheet.getCell((courseIdx + 1), 6).value !== null,
      courseAreas: sheet.getCell((courseIdx + 1), 7).value.toString().split(' ').map((val) => { return +val }),
      courseLeadsTo: null,
      courseRank: null,
      courseHeatmapAreas: null
    }
    CourseDatabase.push(course)
  }

  // Processing holistic features (ie. ones that must be calculated post initilaization)
  CourseDatabase.forEach(course => {
    course.courseLeadsTo = GetCourseLeadsTo(CourseDatabase, course)
    course.courseRank = 0 //GetCourseRank(CourseDatabase, course)
  })

  // // CourseDatabase = CourseMapJSON)


  CourseDatabase = await AttachHeatmapsToCourseDatamap(CourseDatabase)
  // // console.dir(CourseDatabase)

  var x = JSON.stringify(JSON.stringify(CourseDatabase))
  console.log(x)
  // CourseDatabase=JSON.parse(x);

  return CourseDatabase

  */
  const courseData: CourseData[] = data as CourseData[];
  return courseData;
};

export const InitializeHeatmapAreas = async () => {
  //Heatmap parsing
  /*
    const areaIconsArr = [
      'wifi',
      'car',
      'solar-panel',
      'atom',
      'rocket',
      'shield-alt',
      'microchip',
      'x-ray',
      'robot',
      'brain',
      'medkit',
      'database'
    ];
  
    const doc = new GoogleSpreadsheet('1A4PmA1vvH18qIZBPB-gn-ggouTom6zaFCcaX9eP5ps0');
    doc.useApiKey('AIzaSyC_WM4rwzPvsqpdyuF-K_gg9bFhZswbGi8'); //privatize later
    await doc.loadInfo(); // loads document properties and worksheets
    const heatmap_sheet = doc.sheetsByTitle['Focus Areas'];
    await heatmap_sheet.loadCells(`A2:M4`) //zero indexed
  
    let heatmap_areas: HeatmapArea[] = []
    for (var col = 1; col <= 12; col++) {
      let val = heatmap_sheet.getCell(2, col).value
  
      heatmap_areas.push({
        areaName: val.toString(),
        areaDescription: " ",
        areaIcon: areaIconsArr[col - 1],
        areaIndex: col - 1
      })
    }
  */
  // console.log(JSON.stringify(JSON.stringify(heatmap_areas)))

  // return heatmap_areas

  return JSON.parse(staticHeatmapAreas);
};

/*
export const AttachHeatmapsToCourseDatamap = async (CourseDatamap: CourseData[]) => {
  let heatmap_areas = await InitializeHeatmapAreas()

  const doc = new GoogleSpreadsheet('1A4PmA1vvH18qIZBPB-gn-ggouTom6zaFCcaX9eP5ps0');
  doc.useApiKey('AIzaSyC_WM4rwzPvsqpdyuF-K_gg9bFhZswbGi8'); //privatize later
  await doc.loadInfo(); // loads document properties and worksheets
  const heatmap_sheet = doc.sheetsByTitle['Focus Areas'];
  await heatmap_sheet.loadCells(`A3:M70`)
  //heatmap parsing
  const heatmap = [];
  const rowOffset = 4;

  for (var courseIdx = 0; courseIdx < (70 - 4); courseIdx++) {
    let courseCode: string = heatmap_sheet.getCell(courseIdx + rowOffset, 0).value.toString().slice(0, 6)
    let courseRef: CourseData = CourseDatamap.find(el => el.courseCode === courseCode)!
    if (courseRef === undefined) continue //if the course is not found in the heatmap, don't initialize it
    courseRef.courseHeatmapAreas! = []

    for (var col = 1; col <= 12; col++) {
      let val = heatmap_sheet.getCell(courseIdx + rowOffset, col).value
      if (val == null) val = 0;
      courseRef.courseHeatmapAreas!.push({ heatmapArea: heatmap_areas[col], relevance: +val })
    }
    // console.dir("Course " + courseCode + " heatmap")
    // console.dir(courseRef)
  }
  return CourseDatamap
}

*/
export const InitializeSearchBarList = (CourseNodeList: CourseData[]) => {
  var ret: string[] = [];
  CourseNodeList.forEach((course) => {
    ret.push(`${course.courseCode} - ${course.courseName}`);
  });
  return ret;
};

//Iterates through all coursenodes, and within each coursenode, iterates through all connections
//  to generate connectros of all types
export const InitializeCoursemapEdges = (CourseNodeArray: ICourseNode[]) => {
  let ConnectorDatabase: IConnector[] = [];

  // console.dir('Course node array for connectors:')
  // console.dir(CourseNodeArray)

  CourseNodeArray.forEach((course) => {
    let NodeConnectorData: IConnector[] = [];

    //note -- Parses the source reference by searching through the whole arr
    //Standard Prerequisites
    if (course.data.coursePrereqs[0] !== "none") {
      course.data.coursePrereqs.forEach((prereq) => {
        NodeConnectorData.push({
          connType: ConnectorType.PREREQ,
          destNodeRef: course,
          sourceNodeRef: GetCourseNodeByName(CourseNodeArray, prereq),
          styleMode: EdgeMode.NORMAL,
        });
      });
    }

    //Optional Prerequisites
    if (course.data.courseOptPrereqs[0] !== "none") {
      course.data.courseOptPrereqs.forEach((prereq) => {
        NodeConnectorData.push({
          connType: ConnectorType.OPTPREREQ,
          destNodeRef: course,
          sourceNodeRef: GetCourseNodeByName(CourseNodeArray, prereq),
          styleMode: EdgeMode.NORMAL,
        });
      });
    }

    //Related courses (for core nodes only)
    if (course.data.courseRelated[0] !== "none") {
      course.data.courseRelated.forEach((prereq) => {
        NodeConnectorData.push({
          connType: ConnectorType.RELATION,
          destNodeRef: course,
          sourceNodeRef: GetCourseNodeByName(CourseNodeArray, prereq),
          styleMode: EdgeMode.NORMAL,
        });
      });
    }

    //Corequisites
    if (course.data.courseCoreqs[0] !== "none") {
      // console.log("searching coreqs of " + course.data.courseName)
      // console.dir(course.data)
      course.data.courseCoreqs.forEach((coreq) => {
        NodeConnectorData.push({
          connType: ConnectorType.COREQ,
          destNodeRef: course,
          sourceNodeRef: GetCourseNodeByName(CourseNodeArray, coreq),
          styleMode: EdgeMode.NORMAL,
        });
      });
    }
    ConnectorDatabase.push(...NodeConnectorData);
  });
  // console.log("Connector Database")
  // console.dir(ConnectorDatabase)
  return ConnectorDatabase;
};

// Utility Processing Functions
export const GetCourseNodeByName = (
  NodeList: ICourseNode[],
  NodeName: string
) => {
  var match: ICourseNode = NodeList.filter((node) => {
    return node.data.courseCode === NodeName;
  })[0];
  return match;
};

export const GetCourseFirstRelations = (
  NodeList: ICourseNode[],
  NodeCode: string
) => {
  // console.log("finding first relations of " + NodeCode)

  var focus = GetCourseNodeByName(NodeList, NodeCode);
  // var prereqs = node.data.coursePrereqs
  // var coreqs = node.data.courseCoreqs
  // var related = node.data.courseRelated
  // var optprereqs = node.data.courseOptPrereqs
  // NodeList.forEach(node => console.log(node.data.course"noderelations" + node.data.courseRelated))

  //! core relations run in a random direction...

  var firstRelations: ICourseNode[] = NodeList.filter((node) => {
    if (node.homeArea !== focus.homeArea) return false;

    var nodeRelations = node.data.coursePrereqs
      .concat(node.data.courseOptPrereqs)
      .concat(node.data.courseCoreqs)
      .concat(node.data.courseRelated);
    var focusRelations = focus.data.coursePrereqs
      .concat(focus.data.courseOptPrereqs)
      .concat(focus.data.courseCoreqs)
      .concat(focus.data.courseRelated);
    // console.log("First Relation Scanning for Courses " + node.data.courseCode + " and " + focus.data.courseCode)
    // console.dir(nodeRelations)
    // console.dir(focusRelations)
    return (
      focusRelations.includes(node.data.courseCode) ||
      nodeRelations.includes(focus.data.courseCode)
    );

    // (node.data.coursePrereqs.includes(focus.data.courseCode) || focus.data.coursePrereqs.includes(node.data.courseCode) || focus.data.courseCoreqs.includes(node.data.courseCode) || node.data.courseRelated.includes(focus.data.courseCode) || node.data.courseOptPrereqs.includes(focus.data.courseCode) || focus.data.courseRelated.includes(node.data.courseCode))
  });

  firstRelations.push();

  // console.dir(firstRelations)
  return firstRelations;
};

//finds the opportunities a course leads to (w/ extra logic for optional)
// const GetCourseLeadsTo = (
//   NodeList: CourseData[],
//   Node: CourseData
// ): string[] => {
//   var LeadsTo: string[] = [];
//   return LeadsTo;
// };

export const GetCourseNodesOfArea = (
  CourseNodeArray: ICourseNode[],
  Area: number
): ICourseNode[] => {
  return CourseNodeArray.filter(
    (node) => node.data.courseAreas && node.data.courseAreas.includes(Area)
  );
};

const staticHeatmapAreas =
  '[{"areaName":"Wireless / optical / future communications (5G/6G)","areaDescription":" ","areaIcon":"wifi","areaIndex":0},{"areaName":"Electric / Autonomous / Connected Vehicles","areaDescription":" ","areaIcon":"car","areaIndex":1},{"areaName":"Smart-Grid / Renewables / Power Electronics","areaDescription":" ","areaIcon":"solar-panel","areaIndex":2},{"areaName":"Quantum Computing","areaDescription":" ","areaIcon":"atom","areaIndex":3},{"areaName":"Internet-of-things (IoT)","areaDescription":" ","areaIcon":"rocket","areaIndex":4},{"areaName":"Cybersecurity / Privacy / Trust in Networks","areaDescription":" ","areaIcon":"shield-alt","areaIndex":5},{"areaName":"Digital / Analog and Integrated Circuit design","areaDescription":" ","areaIcon":"microchip","areaIndex":6},{"areaName":"Human interface technology / biomedical / photonics / displays","areaDescription":" ","areaIcon":"x-ray","areaIndex":7},{"areaName":"Robotics / Control Systems","areaDescription":" ","areaIcon":"robot","areaIndex":8},{"areaName":"Machine Learning and Artificial Intelligence","areaDescription":" ","areaIcon":"brain","areaIndex":9},{"areaName":"Digital Health","areaDescription":" ","areaIcon":"medkit","areaIndex":10},{"areaName":"Big Data","areaDescription":" ","areaIcon":"database","areaIndex":11}]';
